import { Controller } from "@hotwired/stimulus"

const LOOKUP_LENGTHS = [7, 8, 13]

// Looks up buyer registration type from FBR when NTN/CNIC is entered
export default class extends Controller {
  static targets = [
    "ntn",
    "customerType",
    "regTypeBadge",
    "regTypeSpinner"
  ]

  static debounceTimer = null

  onNtnInput(event) {
    clearTimeout(this.constructor.debounceTimer)
    const ntn = event.target.value.replace(/[-\s]/g, "").trim()

    // NTN = 7 characters, or 8 with the check digit the certificate prints
    // (1234567-5); CNIC = 13 digits. Separators are stripped only to measure the
    // length — /fbr/reg_type re-derives the dashed form FBR's lookup wants via
    // Fbr::Ntn.for_lookup, so it does not matter how the buyer typed it.
    if (!LOOKUP_LENGTHS.includes(ntn.length)) {
      this.clearBadge()
      return
    }

    this.constructor.debounceTimer = setTimeout(() => this.lookupRegType(ntn), 600)
  }

  async lookupRegType(regNo) {
    this.showSpinner()
    try {
      const res  = await fetch(`/fbr/reg_type?registration_no=${encodeURIComponent(regNo)}`)
      const data = await res.json()

      if (data.found) {
        const type = this.normalizeType(data.type)
        this.customerTypeTarget.value = type
        this.showBadge(type, true)
      } else {
        this.showBadge("Not found - defaulting to Unregistered", false)
      }
    } catch (e) {
      console.error("Failed to lookup reg type:", e)
      this.clearBadge()
    } finally {
      this.hideSpinner()
    }
  }

  normalizeType(raw) {
    const lower = raw.toLowerCase()
    if (lower.includes("unregister")) return "Unregistered"
    return "Registered"
  }

  showBadge(text, success) {
    if (!this.hasRegTypeBadgeTarget) return
    const badge = this.regTypeBadgeTarget
    badge.textContent = text
    badge.className = success
      ? "text-xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-700"
      : "text-xs font-semibold px-2 py-0.5 rounded-full bg-amber-100 text-amber-700"
    badge.classList.remove("hidden")
  }

  clearBadge() {
    if (this.hasRegTypeBadgeTarget) this.regTypeBadgeTarget.classList.add("hidden")
  }

  showSpinner() {
    if (this.hasRegTypeSpinnerTarget) this.regTypeSpinnerTarget.classList.remove("hidden")
    this.clearBadge()
  }

  hideSpinner() {
    if (this.hasRegTypeSpinnerTarget) this.regTypeSpinnerTarget.classList.add("hidden")
  }
}
